import { mutationOptions } from '@tanstack/react-query'
import {
  createReportingDraft,
  sendReportingMessage,
} from 'src/queries/reportingAgent/reportingAgent.network'

export const reportingAgentMutations = {
  createDraft: () => mutationOptions({ mutationFn: createReportingDraft }),
  sendMessage: () => mutationOptions({ mutationFn: sendReportingMessage }),
}
